import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ClientManagerInstanceToken, ClientManagerInterface } from '@evorait/pace-core';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class TimesheetResolver implements Resolve<moment.Moment> {
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {}
    public resolve(route: ActivatedRouteSnapshot): moment.Moment {
        if (this.clientManager.isNgmAP0()) {
            const paramDate = route.paramMap.get('date');
            if (paramDate) {
                return moment(paramDate);
            }
        }
        return moment();
    }
}
